import { requestLogin, requestJson, response, request, requestGetMethod } from './functions';
import { axiosInstance, axiosInstanceV2, axiosLoyalty } from './axiosProvider/client';
import { setTokenLoyalty } from 'functions';

export function loginServ(userName, password) {
  const req = requestLogin(userName, password);
  return response('log/login', req);
}

export function getTreeMenuServ(idList) {
  const req = requestJson(idList);
  return response('menu/getTreeMenu', req);
}

export function getMenuServ() {
  const req = requestGetMethod();
  return response('menu/getMenu', req);
}

// export function getGiftGroupCodeFilter() {
//     const req = requestGetMethod()
//     return response('/public/getSystemConFig?name=GIFT_GROUPCODE', req)
// }

export async function checkRecaptcha(params) {
  try {
    const { data } = await axiosInstance.post('public/isValidCaptcha', null, { params: params });
    return data;
  } catch (error) {
    return error;
  }
}

export async function rqGetTokenLoyalty() {
  try {
    const { data } = await axiosLoyalty.get('/loyalty/getTokenLoyalty');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getGiftGroupCodeFilter() {
  try {
    const { data } = await axiosInstance.get('/public/getSystemConFig?name=GIFT_GROUPCODE');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getGeneralAccInfoList(userCode) {
  try {
    return await axiosInstanceV2.get('productInfo/generalAccInfoList', {
      params: { userCode },
    });
  } catch (error) {
    console.log('Cannot get data from api generalAccInfoList', error);
  }
}
